import './antdOverrideStyles.scss';
export default {
  form: { className: 'my-form' },
  modal: { className: 'my-modal' },
  checkbox: { className: 'my-checkbox' },
  button: { className: 'my-button' }
};
